import { useState } from "react";
import ResponseData from "../action/ResponseData.ts";
import { SyncCheckAction } from "./SyncCheckAction.ts";
import SyncCheck from "./SyncCheck.ts";
import { SyncCheckResponseJson } from "./SyncCheckResponseJson.ts";
function useSyncCheckState() {
    const [items, setItems] = useState<Array<SyncCheck> | null>(null);
    const [updated_at, setUpdatedAt] = useState<Date | null>(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const loadedHandler = async (data: ResponseData) => {
        if (data.data) {
            const result = await Promise.resolve(data.data);
            const syncChecks: Array<SyncCheckResponseJson> = result.check;
            const rooms: Array<{ id: number; name: string }> = result.rooms;

            setItems(
                syncChecks.map((syncCheck: SyncCheckResponseJson) => {
                    const room = rooms.find((r) => r.id === syncCheck.room_id);
                    const roomName = room ? room.name : null;
                    return new SyncCheck(
                        syncCheck.result,
                        syncCheck.year,
                        syncCheck.month,
                        syncCheck.room_id,
                        roomName,
                        new Date(syncCheck.created_at),
                        syncCheck.status
                    );
                })
            );
            //console.log("loadedHandler", data.data);
        }
    };
    const createdHandler = async (data: ResponseData) => {
        if (data.data) {
            setUpdatedAt(new Date());
            //console.log("loadedHandler", data.data);
        }
        setIsLoading(false);
    };

    const errorHandler = (data: ResponseData) => {
        setError(data.error);
        setIsLoading(false);
    };

    const getSyncCheck = (token: string, accommodation_id: number) => {
        SyncCheckAction.getDetail(token, accommodation_id, loadedHandler, errorHandler);
    };

    const createSyncCheck = (token: string, accommodation_id: number, differ_in_month: number) => {
        setIsLoading(true);
        SyncCheckAction.create(token, accommodation_id, differ_in_month, createdHandler, errorHandler);
    };

    return {
        accommodation_error: error,
        syncChecks: items,
        sync_updated_at: updated_at,
        isLoading,
        getSyncCheck,
        createSyncCheck,
    };
}

export default useSyncCheckState;
